import { useFilterOptions } from './useFiltersOptions';
import sortOptions from '@/constants/sortOptions';

export const useActiveFilterStore = useFilterOptions(
  'activeFilterStore',
  'api/transport-requests/manage/Active',
  {
    sortObj: sortOptions.dispatchedDate
  },
);
